<template>
  <BlockContainer class="smallBasicPremiumCard">
    <div class="d-flex align-items-center mb-4">
      <div>
        <i class="h4 budicon-star" />
      </div>
      <h5 class="ml-4">Bekymringsfri utleie</h5>
    </div>
    <p class="mt-4">
      Oppgrader til Basic eller Premium så får du tilgang til alle verktøyene du behøver for enkel, trygg og lønnsom
      boligutleie
    </p>
    <div class="smallBasicPremiumCard__content">
      <div>
        <div v-for="(benefit, index) in leftBenefits" :key="index" class="smallBasicPremiumCard__content__benefit">
          <span>
            <i class="h4 budicon-check-ui text-primary" />
          </span>
          <span>{{ benefit }}</span>
        </div>
        <div class="smallBasicPremiumCard__content__priceContainer">
          <span>Fra kr.</span>
          <div class="ml-2">
            <span class="h2 text-primary">99</span>
            <span class="ml-1">/måned</span>
          </div>
        </div>
        <button class="btn btn-primary mt-3" @click="goToBasicSubscriptionView">Se alle fordeler</button>
      </div>
      <div class="smallBasicPremiumCard__content__right">
        <div class="smallBasicPremiumCard__content__rightBenefits">
          <div v-for="(benefit, index) in rightBenefits" :key="index" class="smallBasicPremiumCard__content__benefit">
            <span>
              <i class="h4 budicon-check-ui text-primary" />
            </span>
            <span>{{ benefit }}</span>
          </div>
          <p>Og mye mer..</p>
        </div>
      </div>
    </div>
  </BlockContainer>
</template>

<script>
import Vue from 'vue';
import BlockContainer from '@/components/BlockContainer';

export default Vue.extend({
  name: 'SmallBasicPremiumCard',
  components: {
    BlockContainer,
  },
  computed: {
    leftBenefits() {
      return ['Ingen oppsigelsestid', '3 mnd fornøydgaranti', 'Ingen oppstartsgebyr'];
    },
    rightBenefits() {
      return [
        'Fakturering av husleien',
        'Betalingsoppfølging',
        'Bistand til utkastelse',
        'Depositumskonto',
        'Telefonsupport',
      ];
    },
  },
  methods: {
    goToBasicSubscriptionView() {
      this.$router.push({
        name: 'subscription_basic',
      });
    },
  },
});
</script>

<style lang="scss">
.smallBasicPremiumCard {
  background: #ecf8f2 !important;
  padding: 1.5rem 1.5rem;
}
.smallBasicPremiumCard__content {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
.smallBasicPremiumCard__content__right {
  display: none;
}
.smallBasicPremiumCard__content__benefit {
  display: flex;
  align-items: center;
  gap: 0rem 0.5rem;
}
.smallBasicPremiumCard__content__priceContainer {
  display: flex;
  margin-top: 1.5rem;
}
.smallBasicPremiumCard__content__rightBenefits {
  background: white;
  padding: 1rem 2rem;
  padding-right: 6rem;
  border: 1px solid $gray-200;
}
.smallBasicPremiumCard__content__rightBenefits p {
  margin-left: 2rem;
  margin-bottom: 0px;
}

@media only screen and (min-width: 600px) {
  .smallBasicPremiumCard__content__right {
    display: block;
  }
}
</style>
